// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n/* Add your custom styles here */\nbody[data-v-1f03dde3] {\n    font-family: 'Arial', sans-serif;\n    line-height: 1.6;\n    color: #333;\n    margin: 0;\n    padding: 0;\n}\nsection[data-v-1f03dde3] {\n    padding: 20px;\n}\np[data-v-1f03dde3] {\n    margin-bottom: 20px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
